import {
  Typography,
  Grid,
  List,
  ListItemIcon,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CircleIcon from "@mui/icons-material/Circle";
import { styles, sxStyles, iconStyle } from "./glossaryData.styles";

const iconEye = <RemoveRedEyeIcon style={iconStyle} />;

export const htaMaintenanceGlossaryData = (t) => ({
  rows: [
    {
      parameter: "name",
      detail: "complete_name_patient",
      behavior: "-",
      align: { behavior: "center" },
    },
    {
      parameter: "antiquity",
      detail: "time_elapsed_enrollment",
      behavior: "-",
      align: { behavior: "center" },
    },
    {
      parameter: "weight",
      detail: "weight_patient",
      behavior: "-",
      align: { behavior: "center" },
    },
    {
      parameter: "measurement_quantity",
      detail: "amount_measurements_maintenance",
      behavior: (
        <Grid container direction="column" spacing={1}>
          <Grid item>{t("measurement_require")}</Grid>
          <Grid item>{t("measurement_expreshimself")}</Grid>
          <Grid item>{t("exam")}&nbsp;:&nbsp;12</Grid>
        </Grid>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "bp_average",
      detail: "average_ta_maintenance",
      behavior: (
        <>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_lest_than")}&nbsp;
              <span style={styles.success}> 120 / 85</span>
            </ListItemIcon>
          </List>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_yellow")}&nbsp;
              <span style={styles.warning}> 140 / 90</span>
            </ListItemIcon>
          </List>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_red")}&nbsp;
              <span style={styles.error}> 185 / 100</span>
            </ListItemIcon>
          </List>
        </>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "hr_average",
      detail: "average_hr_maintenance",
      behavior: (
        <Grid container direction="column" spacing={1}>
          <Grid item> {t("hr_average")}</Grid>
          <Grid item>{t("exam")}&nbsp;:&nbsp;95</Grid>
        </Grid>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "bp_max",
      detail: "blood_pressure_max_maintenance",
      behavior: (
        <>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_lest_than")}&nbsp;
              <span style={styles.success}>120 / 80</span>
            </ListItemIcon>
          </List>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_yellow")}&nbsp;
              <span style={styles.warning}>160 / 90</span>
            </ListItemIcon>
          </List>
          <List>
            <ListItemIcon sx={sxStyles.listItemIcon}>
              <CircleIcon sx={sxStyles.circleIcon} />
              {t("average_red")}&nbsp;
              <span style={styles.error}>190 / 100</span>
            </ListItemIcon>
          </List>
        </>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "hr_max",
      detail: "max_hr_maintenance",
      behavior: (
        <Grid container direction="column" spacing={1}>
          <Grid item>{t("fc_max")}</Grid>
          <Grid item>{t("exam")}&nbsp;:&nbsp;95</Grid>
        </Grid>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "ta_sistolica_outside_rang",
      detail: "average_ta_outside_maintenance",
      behavior: (
        <Grid container direction="column" spacing={1}>
          <Grid item>{t("values_greater")}</Grid>
          <Grid item>{t("exam")}&nbsp;:&nbsp;5%</Grid>
        </Grid>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "ta_diastolica_outside_rang",
      detail: "ta_diastolica_outside_rang_maintenance",
      behavior: (
        <Grid container direction="column" spacing={1}>
          <Grid item>{t("%_outside")}</Grid>
          <Grid item>{t("exam")}&nbsp;:&nbsp;3%</Grid>
        </Grid>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "actions",
      detail: (
        <Typography sx={styles.cells}>
          <Grid container direction="column" spacing={8}>
            <Grid item xs={6}>
              {t("see")} {iconEye} : {t("allows_you_see")}
            </Grid>
          </Grid>
        </Typography>
      ),
      behavior: (
        <Typography sx={styles.cells}>
          <Grid container direction="column" spacing={8}>
            <Grid item xs={6} align="justify">
              {t("select_icon_ayes_redirect")}
            </Grid>
          </Grid>
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
  ],
  footerNote: "note",
});
